<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Kundenkarten</h4>
        </div>
    </div>

    <div class="row" [formGroup]="filterForm">
        <div class="col-sm-3">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suche</mat-label>
                <input type="text" matInput formControlName="searchTerm" placeholder="suchen.."
                    (keydown)="onKeydown($event)">
            </mat-form-field>
        </div>
        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Status</mat-label>
                <mat-select formControlName="filterByState">
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByState.value != null ">
                            {{this.filterForm.controls.filterByState.value | translateFilterCard : 'filterState'}}
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of states" [disabled]="sortOption.state"
                        [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row marginBottom2Rem">
        <div class="col-sm-12 ">
            <button mat-button mat-raised-button color="accent" (click)="filterCards()">
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFitler()" style="margin-left: 15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let card; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ID">
                        <th mat-header-cell *matHeaderCellDef>
                            Kennung
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            {{card.number}} ({{card.cardId}})
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef>
                            Besitzer
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            {{card?.userModel?.person?.displayName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected *ngIf="card.state == 'ACTIVE' ">
                                    {{card.state | translateState}}
                                </mat-chip>
                                <mat-chip disabled *ngIf="card.state != 'ACTIVE' ">
                                    {{card.state | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>
                            Erstellt
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            {{card.created | date : 'dd.MM.yyyy hh:mm'}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="last_change">
                        <th mat-header-cell *matHeaderCellDef>
                            Letzte Änderung
                        </th>
                        <td mat-cell *matCellDef="let card" class="mat-column">
                            {{card.lastModified | date : 'dd.MM.yyyy hh:mm' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let card">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="['edit', card.publicId]" [disabled]="card.ownerPublicId == null">
                                    <span>Bearbeiten</span>
                                </button>
                                <button mat-menu-item [routerLink]="['history', card.publicId]" [disabled]="card.ownerPublicId == null">
                                    <span>Karten-Historie</span>
                                </button>
                                <button mat-menu-item (click)="openQRCodeDialog(card)" [disabled]="card.ownerPublicId == null"> 
                                    <span>QR-Code</span>
                                </button>
                                <button mat-menu-item [matMenuTriggerFor]="edit" [disabled]="card.ownerPublicId == null">Dokumente runterladen</button>

                                <button mat-menu-item (click)="closeCard(card)" [disabled]="card.ownerPublicId == null"
                                    *ngIf="card.state != 'CLOSED' && card.state != 'CLOSE_REQUEST'">
                                    <span>Karte sperren</span>
                                </button>

                                <button mat-menu-item (click)="reopenCard(card)" [disabled]="card.ownerPublicId == null" *ngIf="card.state == 'CLOSE_REQUEST'">
                                    <span> Alte Karte wieder freischalten</span>
                                </button> 


                                <button mat-menu-item [routerLink]="['files', card.publicId]" [disabled]="card.ownerPublicId == null">  Exportierte Dateien</button>

                              

 

                           </mat-menu>
                            <mat-menu #edit="matMenu">
                                <button mat-menu-item (click)="getCardPDF(card)">
                                    <span> Karte (PDF)</span>
                                </button>
                                <button mat-menu-item (click)="getCardNotificationPDF(card)">
                                    <span> Kartenanschreiben (PDF)</span>
                                </button>
                            </mat-menu>
<!-- 
                            <mat-menu #files="matMenu">
                                <button mat-menu-item  *ngFor="let file of  card['producedFiles'] "(click)="downloadFile(file)">
                                    <span> {{file.name}}</span>
                                </button>


                               
                            </mat-menu>
                         -->





                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index"></tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine passenden
                    Einträge
                    gefunden...</span>
                <mat-paginator [length]="page.totalElements" class="paginator-centered  mat-elevation-z2"
                    [pageSize]="page.size" [pageIndex]="page.number" (page)="loadPage($event)"
                    [pageSizeOptions]="[6, 12, 24, 36]" *ngIf="page">
                </mat-paginator>

            </div>
            <!-- <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button> -->
        </div>
    </div>
</div>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>